import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { Button } from "@mui/material";
import AppDialogDefault from "@/components/ui/appDialogDefault/AppDialogDefault.component";
import type { ResumoAlteracoes } from "./restricoes.utils";
import ResumoAlteracoesPainel from "./ResumoAlteracoesPainel";
import Can, { type CanEstado } from "@/permissoes/Can";
import { PERMISSOES_RESTRICOES } from "./restricoes.constants";

// --------------------------------- TYPES ---------------------------------
type DialogConfirmarSalvarProps = {
	readonly bloqueado?: boolean;
	readonly permissao: CanEstado;
	readonly aberto: boolean;
	readonly salvando: boolean;
	readonly grupoNome: string;
	readonly resumo: ResumoAlteracoes;
	readonly acoes: {
		readonly onFechar: () => void;
		readonly onConfirmar: () => void;
	};
};

// ------------------------------- COMPONENT -------------------------------
export default function DialogConfirmarSalvar({
	bloqueado = false,
	permissao,
	aberto,
	salvando,
	grupoNome,
	resumo,
	acoes,
}: Readonly<DialogConfirmarSalvarProps>) {
	const subtitulo = resumo.total === 1 ? "1 alteração será aplicada" : `${resumo.total} alterações serão aplicadas`;

	return (
		<AppDialogDefault
			aberto={aberto}
			onFechar={acoes.onFechar}
			titulo={`Confirmar alterações · ${grupoNome}`}
			subtitulo={subtitulo}
			icone="lucide:save"
			maxWidth="sm"
			exibirBotaoFecharRodape={false}
			impedirFecharBackdrop
			bodyClassName="overflow-hidden"
			actionsClassName="shrink-0 gap-2 p-3"
			acoesRodape={
				<>
					<Button
						variant="contained"
						color="error"
						size="small"
						onClick={acoes.onFechar}
						disabled={salvando}
						startIcon={<FuseSvgIcon size={16}>lucide:x</FuseSvgIcon>}
					>
						Cancelar
					</Button>
					<Can
						tag={PERMISSOES_RESTRICOES.salvar}
						tipoGrupo="USUARIO"
						modo="desabilitar"
						estado={permissao}
						tooltip={
							permissao.carregando
								? "Verificando permissão para salvar restrições…"
								: "Você não tem permissão para salvar restrições."
						}
						tooltipPlacement="right"
					>
						<Button
							variant="contained"
							color="success"
							size="small"
							onClick={acoes.onConfirmar}
							disabled={
								bloqueado ||
								salvando ||
								resumo.total === 0 ||
								!permissao.permitido ||
								permissao.carregando
							}
							startIcon={<FuseSvgIcon size={16}>lucide:check</FuseSvgIcon>}
						>
							{salvando ? "Salvando…" : "Confirmar e salvar"}
						</Button>
					</Can>
				</>
			}
		>
			<ResumoAlteracoesPainel resumo={resumo} />
		</AppDialogDefault>
	);
}
